import React, { useRef } from 'react';
import { theme } from '../../../theme';
import type { TimeBin } from './KalenderwocheBarChart';
import { useEChartsLifecycle, STD_TOOLTIP_STYLE, makeCountTooltipFormatter } from './_chartCommon';

// <purpose>KW.Verlauf — stepped area, count labels above each step.</purpose>

type Props = {
  data: TimeBin[];
  filterHash?: string;
};

export const KwVerlauf: React.FC<Props> = ({ data, filterHash }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const NAVY = theme.colors.navy;

  useEChartsLifecycle(containerRef, chart => {
    chart.setOption({
      grid: { left: 36, right: 16, top: 30, bottom: 26 },
      tooltip: {
        ...STD_TOOLTIP_STYLE,
        trigger: 'axis',
        axisPointer: { type: 'line', lineStyle: { color: NAVY, opacity: 0.35, width: 1 } },
        formatter: makeCountTooltipFormatter(NAVY),
      },
      xAxis: {
        type: 'category',
        data: data.map(d => d.label),
        axisLine: { lineStyle: { color: '#dde0e8' } },
        axisTick: { show: false },
        axisLabel: { color: '#9095a3', fontSize: 9, interval: data.length > 16 ? 1 : 0 },
      },
      yAxis: {
        type: 'value',
        splitLine: { lineStyle: { color: '#f1f2f6' } },
        axisLabel: { color: '#9095a3', fontSize: 9 },
        axisLine: { show: false },
        axisTick: { show: false },
      },
      series: [{
        type: 'line',
        data: data.map(d => d.count),
        step: 'middle',
        symbol: 'circle',
        symbolSize: 5,
        itemStyle: { color: 'white', borderColor: NAVY, borderWidth: 1.5 },
        lineStyle: { color: NAVY, width: 1.5 },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(6,16,90,0.22)' },
              { offset: 1, color: 'rgba(6,16,90,0.01)' },
            ],
          },
        },
        emphasis: {
          scale: 1.6,
          itemStyle: { color: NAVY, borderColor: 'white', borderWidth: 2, shadowColor: 'rgba(6,16,90,0.45)', shadowBlur: 10 },
        },
        label: { show: true, position: 'top', color: NAVY, fontSize: 10, fontWeight: 600 },
      }],
    });
  }, [data, filterHash]);

  return <div ref={containerRef} style={{ width: '100%', height: 220 }} />;
};
